import { getColumns } from '@eeacms/volto-columns-block/ColumnsBlock/utils';
import { COLUMNSBLOCK } from '@eeacms/volto-columns-block/constants';
import { getStyle } from '@eeacms/volto-columns-block/Styles';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import config from '@plone/volto/registry';
import cx from 'classnames';
import { useLocation } from 'react-router-dom';
import { Container, Grid } from 'semantic-ui-react';

import styles from './ColumnsBlock.module.less';

if (typeof window !== 'undefined') {
  function _calculateScrollbarWidth() {
    const root = document.documentElement;

    root.style.setProperty(
      '--scrollbar-width',
      window.innerWidth - root.clientWidth + 'px',
    );
    root.style.setProperty('--document-width', root.clientWidth + 'px');
  }

  // calculate as soon as possible to avoid first paint horizontal jump
  _calculateScrollbarWidth();

  // recalculate on resize
  window.addEventListener('resize', _calculateScrollbarWidth, false);
}

const ColumnsBlockView = (props) => {
  const location = useLocation();
  const { gridSizes } = config.blocks.blocksConfig[COLUMNSBLOCK];
  const {
    data = {},
    gridSize = 12,
    gridCols = [],
    fullWidth = 'none',
    useBackground,
    backgroundColor,
    increasePadding,
  } = props.data;
  const metadata = props.metadata || props.properties;
  const columnList = getColumns(data);
  const customId = props.data?.title
    ?.toLowerCase()
    ?.replace(/[^a-zA-Z-\s]/gi, '')
    ?.trim()
    ?.replace(/\s+/gi, '-');

  const normalizedBackgroundColor =
    backgroundColor === 'darkBlue' ? 'darkBlue' : 'grey';
  const hasBackground = !!useBackground;

  const blockClasses = cx('columns-block', 'columns-wrapper', styles.block, {
    [styles.back]: hasBackground && normalizedBackgroundColor === 'grey',
    [styles.backDarkBlue]:
      hasBackground && normalizedBackgroundColor === 'darkBlue',
    [styles.none]: fullWidth === 'none',
    [styles.full]: fullWidth === 'background',
    [styles.cont]: fullWidth === 'all',
    [styles.pad]: increasePadding,
  });

  const gridClasses = cx('column-grid');

  // Verifica se todas as colunas têm o mesmo tamanho
  const equalColumns = gridCols.every((col) => col === gridCols[0]);

  return (
    <div id={customId} className={blockClasses}>
      <Container className={styles.wrap}>
        <Grid
          columns={equalColumns ? gridCols.length : gridSize}
          className={gridClasses}
          stackable
          reversed={props.data?.reverseWrap ? 'mobile' : undefined}
        >
          {columnList.map(([id, column], index) => {
            return (
              <Grid.Column
                key={id}
                {...(!equalColumns &&
                  (gridSizes[gridCols[index]] || gridCols[index]))}
                className={cx(
                  'column-blocks-wrapper',
                  column.settings?.column_class,
                  styles.col,
                )}
                {...getStyle(column.settings || {})}
              >
                <RenderBlocks
                  {...props}
                  location={location}
                  metadata={metadata}
                  content={column}
                />
              </Grid.Column>
            );
          })}
        </Grid>
      </Container>
    </div>
  );
};

export default ColumnsBlockView;
